// src/data/pseudoLegendaries.js
export const pseudoLegendaryPokemon = [
  'dragonite', 'tyranitar', 'salamence', 'metagross', 
  'garchomp', 'hydreigon', 'goodra', 'kommo-o', 'dragapult',
  'baxcalibur'
];